import type { AvailableGreenhouseStockDto } from "../services/sowingInstructionsApi";

export const isPerTrayPricing = (mode: unknown): boolean =>
  mode === 1 || mode === "1" || mode === "PerTray";

export const isPerSeedlingPricing = (mode: unknown): boolean =>
  mode === 2 || mode === "2" || mode === "PerSeedlingOrPiece";

export const commercialOrderQuantity = (quantity: string, pricingMode: unknown, trayType: number) => ({
  quantity: Number(quantity),
  unit: isPerSeedlingPricing(pricingMode) ? 5 : 11,
  ...(isPerSeedlingPricing(pricingMode) ? {} : { trayType }),
});

const normalize = (value?: string | null) => (value ?? "").trim().toLowerCase();

export interface OrderStockTarget {
  cropTypeId?: string;
  cropTypeName?: string;
  variety?: string | null;
  pricingMode: unknown;
  trayType?: number | null;
}

// Quantities on the source stay in native units. Physical pieces are supplied by
// the server; availableSeedlings/buffered tray capacity must not be used here.
export const availableInOrderUnits = (
  entry: AvailableGreenhouseStockDto,
  pricingMode: unknown,
): number => {
  if (isPerSeedlingPricing(pricingMode)) {
    return entry.availablePhysicalPieces ??
      (normalize(entry.stockUnit) === "pieces" ? entry.availableQuantity : 0);
  }
  return entry.availableQuantity;
};

export const stockMatchesOrder = (
  entry: AvailableGreenhouseStockDto,
  target: OrderStockTarget,
): boolean => {
  if (entry.isCompanyStock === false) return false;
  const cropMatches = entry.cropTypeId && target.cropTypeId
    ? normalize(entry.cropTypeId) === normalize(target.cropTypeId)
    : !!normalize(target.cropTypeName) && normalize(entry.cropTypeName) === normalize(target.cropTypeName);
  if (!cropMatches || normalize(entry.variety) !== normalize(target.variety)) return false;

  if (isPerSeedlingPricing(target.pricingMode)) {
    return ["pieces", "trays"].includes(normalize(entry.stockUnit)) &&
      availableInOrderUnits(entry, target.pricingMode) > 0;
  }
  return isPerTrayPricing(target.pricingMode) && isPerTrayPricing(entry.pricingMode) &&
    normalize(entry.stockUnit) === "trays" && !!target.trayType &&
    entry.trayTypeInt === target.trayType;
};
